import React from 'react';
import {inject, observer} from "mobx-react";
import {Route, Switch, withRouter} from "react-router-dom";
import {DiagnosisEndTemplate, DiagnosisIntroTemplate, DiagnosisTemplate} from './templates';

export default
@inject( 'DiagnosisStore' )
@withRouter
@observer
class DiagnosisContainer extends React.Component {
    render() {
        const { match } = this.props;

        return (
            <>
                <Switch>
                    <Route exact path={match.url} component={DiagnosisIntroTemplate} />
                    <Route path="/test" component={DiagnosisTemplate} />
                    <Route path="/end" component={DiagnosisEndTemplate} />
                </Switch>
            </>
        )
    }
}
